import StatisticalAnalysisSkeletonDossierNavigationItems from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-dossier-navigation-items/statistical-analysis-skeleton-dossier-navigation-items.vue'
import StatisticalAnalysisSkeletonIncidentDossierWidgets from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-incident-dossier/statistical-analysis-skeleton-incident-dossier-widgets/statistical-analysis-skeleton-incident-dossier-widgets.vue'
import StatisticalAnalysisSkeletonTable from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-table/statistical-analysis-skeleton-table.vue'
import { Vue, Component } from 'vue-property-decorator'

@Component({
    components: {
        StatisticalAnalysisSkeletonDossierNavigationItems,
        StatisticalAnalysisSkeletonTable,
        StatisticalAnalysisSkeletonIncidentDossierWidgets
    }
})
export default class StatisticalAnalysisSkeletonIncidentDossierBase extends Vue {}
